export default __webpack_public_path__ + "static/media/folio-joint.73bac202.svg";